import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import LayoutFixHome from "../components/LayoutFixHome";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import { useEffect, useState } from "react";
import ClientCard from "../components/ClientCard";
import CanalDisplay from "../components/CanalDisplay";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import StatusHistoryModal from "../components/StatusHistoryModal";
import { getProcessbyCode, getProcessUrf } from "../services/clientService";
import { toast } from "react-toastify";
import { useSelectedItemStore } from "../store/useSelectedItemStore";
import { useUserStore } from "../store/userStore";
import MAPAModal from "../components/MAPAModal";
import SefazModal from "../components/SefazModal";
import DataEntregaTransportador from "../components/DataEntregaTransportador";

const DetailsPage = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(RoutesConfig.HOME.path);
  };
  const [openHystModal, setHystModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resultProcess, setResultProcess] = useState<any>([]);
  const [viaTransporte, setViaTransporte] = useState("");
  const selectedItemId = useSelectedItemStore((state) => state.selectedItemId);
  const profile = useUserStore((state) => state.profile);
  const [openMapaModal, setMapaModal] = useState(false);
  const [openSefazModal, setSefazModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [resultUrfDespacho, setResultUrfDespacho] = useState<any>();
  const [resultUrfEntrada, setResultUrfEntrada] = useState<any>();

  const handleViaTransporte = (via: string) => {
    switch (via) {
      case "1":
        return setViaTransporte("Marítimo");
      case "4":
        return setViaTransporte("Aéreo");
      default:
        return setViaTransporte("Ñ identificado");
    }
  };

  const getProcess = async () => {
    if (!selectedItemId) return;

    setIsLoading(true);
    try {
      const data = await getProcessbyCode(selectedItemId);
      setResultProcess(data);
    } catch (err) {
      toast.error("Erro ao buscar detalhes do processo");
      console.error("Erro ao buscar detalhes do processo:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProcess();
  }, []);

  const getProcessByUrf = async () => {
    try {
      if (resultProcess.CD_URF_DESPACHO) {
        const dataDespacho = await getProcessUrf(resultProcess.CD_URF_DESPACHO);
        setResultUrfDespacho(dataDespacho);
      }

      if (resultProcess.CD_URF_ENTRADA) {
        const dataEmbarque = await getProcessUrf(resultProcess.CD_URF_ENTRADA);
        setResultUrfEntrada(dataEmbarque);
      }
    } catch (err) {
      toast.error("Erro ao buscar URFs do processo");
      console.error("Erro ao buscar URFs do processo:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (resultProcess) {
      getProcessByUrf();
    }
  }, [resultProcess]);

  const statusList = resultProcess?.HISTORICO?.map((item: any) => {
    const info = item.INF_HISTORICO || "";
    const maybeDate = info.substring(0, 5);
    const isDate = /^\d{2}\/\d{2}$/.test(maybeDate);

    const datePart = isDate ? maybeDate : "sem data";
    const description = isDate
      ? info.substring(7).trim()
      : info.trim() || "sem descrição";

    return {
      date: datePart,
      status: description,
      completed: true,
    };
  });

  useEffect(() => {
    if (resultProcess?.CD_VIA_TRANSPORTE) {
      handleViaTransporte(resultProcess.CD_VIA_TRANSPORTE);
    }
  }, [resultProcess]);

  return (
    <div>
      <LayoutFixHome>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "45px",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop:
                isMobile && profile[0] === "cliente"
                  ? "150px"
                  : isMobile && profile[0] !== "cliente"
                  ? "75px"
                  : 0,
              cursor: "pointer",
            }}
          >
            <div onClick={handleBack}>
              <ExpandCircleDownOutlinedIcon
                style={{ transform: "rotate(-270deg)" }}
                sx={{ color: "#0A0C33", height: "30px", width: "30px" }}
              />
            </div>
            <Typography
              variant="h5"
              color="text.secondary"
              sx={{
                fontWeight: "bold",
                color: "#0A0C33",
                marginLeft: "10px",
              }}
            >
              {isMobile ? "Detalhes" : "Detalhamento"}
            </Typography>
          </div>
          {(profile[0] === "admin" || profile[0] === "analista") && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginTop: {
                  sm: "75px",
                  xs: "75px",
                  md: 0,
                },
              }}
            >
              <Button
                sx={{
                  textTransform: "none",
                  backgroundColor: "#326AFD",
                  color: "#FFFFFF",
                  borderRadius: "27px",
                  fontSize: "16px",
                  fontWeight: "700",
                  width: "202px",
                  marginLeft: isMobile ? "8px" : 0,
                }}
                onClick={() => navigate(RoutesConfig.MEUSPROCESSOS.path)}
              >
                <InsertLinkIcon
                  sx={{ transform: "rotate(45deg)", marginRight: "5px" }}
                />
                Meus Processos
              </Button>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "24px",
            "@media (max-width: 799px)": {
              flexDirection: "column",
              alignItems: "center",
            },
          }}
        >
          <ClientCard
            processNumber={resultProcess.CD_PROCESSO}
            refNumber={resultProcess.CD_CLIENTE}
          />

          <Paper
            sx={{
              flex: 1,
              p: 2,
              minWidth: "280px",
              border: "1px solid #0A0C33",
              borderRadius: "15px",
              boxShadow: "none",
              height: "80vh",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  Número da DI:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={resultProcess.NR_DI}
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "center" },
                  }}
                  style={{ borderRadius: "5px" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  B/L:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={resultProcess.NR_DOC_CARGA ?? "--"}
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "center" },
                  }}
                  style={{ borderRadius: "5px" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  INVOICE:
                </Typography>
                <Tooltip
                  title={
                    resultProcess.NR_DOC_INSTR?.length > 0
                      ? resultProcess.NR_DOC_INSTR
                      : ""
                  }
                  arrow
                >
                  <TextField
                    fullWidth
                    size="small"
                    value={resultProcess.NR_DOC_INSTR}
                    inputProps={{
                      readOnly: true,
                      style: { textAlign: "center" },
                    }}
                    style={{ borderRadius: "5px" }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  Número do Container:
                </Typography>
                <Tooltip
                  title={
                    resultProcess.NR_CONTAINER?.length > 0 ? (
                      <div>
                        {resultProcess.NR_CONTAINER.map(
                          (container: any, index: any) => (
                            <div key={index}>{container}</div>
                          )
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  arrow
                >
                  <TextField
                    fullWidth
                    size="small"
                    value={resultProcess.NR_CONTAINER ?? "--"}
                    inputProps={{
                      readOnly: true,
                      style: { textAlign: "center" },
                    }}
                    style={{ borderRadius: "5px" }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  Embarque:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={viaTransporte}
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "center" },
                  }}
                  style={{ borderRadius: "5px" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
                >
                  Status:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={resultProcess.HISTORICO?.[0]?.INF_HISTORICO ?? "--"}
                  inputProps={{
                    readOnly: true,
                    style: { textAlign: "center" },
                  }}
                  style={{ borderRadius: "5px" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, textAlign: "left", fontWeight: 600 }}
                >
                  URF Embarque:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={resultUrfEntrada?.name ?? "--"}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 0.5, textAlign: "left", fontWeight: 600 }}
                >
                  URF Despacho:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={resultUrfDespacho?.name ?? "--"}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <div onClick={() => setHystModal(true)}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontWeight: 600,
                      textAlign: "right",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Consultar histórico
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: "2px" }}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, textAlign: "left", marginTop: 0 }}
                >
                  Canal de Parametrização:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} style={{ paddingTop: "5px" }}>
                <CanalDisplay
                  value={resultProcess.CANAL}
                  title="Receita Federal:"
                />
              </Grid>
              <Grid item xs={12} md={6} style={{ paddingTop: "5px" }}>
                <CanalDisplay
                  value={resultProcess.IN_CANAL_SEFAZ}
                  title="SEFAZ:"
                />
              </Grid>
              <Grid item xs={12} style={{ paddingTop: "5px" }}>
                <DataEntregaTransportador
                  dataEntrega={resultProcess.DT_ENTREGA ?? ""}
                />
              </Grid>
              <Grid item xs={8} md={8}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: isMobile ? "10px" : "15px",
                  }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: "#326AFD", borderRadius: "20px" }}
                    sx={{ textTransform: "none" }}
                    onClick={() => setMapaModal(true)}
                  >
                    Consultar MAPA
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={8} md={8}>
                <Button
                  variant="contained"
                  fullWidth
                  style={{ backgroundColor: "#326AFD", borderRadius: "20px" }}
                  sx={{ textTransform: "none" }}
                  onClick={() => setSefazModal(true)}
                >
                  Consultar SEFAZ
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </LayoutFixHome>
      <StatusHistoryModal
        open={openHystModal}
        onClose={() => setHystModal(false)}
        list={statusList}
      />
      <MAPAModal
        open={openMapaModal}
        onClose={() => setMapaModal(false)}
        codigo={resultProcess.CD_PROCESSO}
      />
      <SefazModal
        open={openSefazModal}
        onClose={() => setSefazModal(false)}
        codigo={resultProcess.CD_PROCESSO}
        canal={resultProcess.IN_CANAL_SEFAZ}
      />
    </div>
  );
};

export default DetailsPage;
